import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/index";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";

import "./index.scss";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
require("react-datepicker/dist/react-datepicker-cssmodules.css");
const container = document.getElementById("root");
const root = createRoot(container);
const app = (
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
root.render(app);
serviceWorkerRegistration.register();
